import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import cliAutoEligibilityAPI from 'services/creditLineIncreaseAuto/cliEligibility'
import cliAutoAPI from 'services/creditLineIncreaseAuto'
import { CliRequestPayload, CreditLimitIncreaseAuto } from 'typings/cliRequest'

export const initState: CreditLimitIncreaseAuto = {
  requestStatus: 'initial',
  error: false,
  errorMessage: '',
  isUserEligible: false,
  eligibilityRequestStatus: 'initial'
}

export const requestCliAutoEligibility = createAsyncThunk(
  'creditLimitIncreaseAutoSlice/requestCreditLimitIncreaseEligibility',
  async (payload: {
    currentCreditLimit: string
    accessToken: string
    accountId: string
  }) => {
    return cliAutoEligibilityAPI.checkEligibility(payload)
  }
)

export const requestCreditLimitIncreaseAuto = createAsyncThunk(
  'creditLimitIncreaseAutoSlice/requestCreditLimitIncrease',
  async (payload: CliRequestPayload) => {
    return cliAutoAPI.updateCreditLimitIncreaseAuto(payload)
  }
)

const creditLimitIncreaseAutoSlice = createSlice({
  name: 'creditLimitIncreaseAutoSlice',
  initialState: initState,
  reducers: {
    resetCreditLineIncreaseAutoState: () => {
      return initState
    }
  },
  extraReducers: builder => {
    builder
      .addCase(
        requestCreditLimitIncreaseAuto.pending,
        (state: CreditLimitIncreaseAuto) => {
          state.requestStatus = 'pending'
        }
      )
      .addCase(
        requestCreditLimitIncreaseAuto.fulfilled,
        (state: CreditLimitIncreaseAuto, { payload }) => {
          state.requestStatus = 'success'
          state.decisionStatus = payload.decisionStatus
          state.partiallyApprovedCreditLimit =
            payload.partiallyApprovedCreditLimit
        }
      )
      .addCase(
        requestCliAutoEligibility.pending,
        (state: CreditLimitIncreaseAuto) => {
          state.eligibilityRequestStatus = 'pending'
        }
      )
      .addCase(
        requestCliAutoEligibility.fulfilled,
        (state: CreditLimitIncreaseAuto, { payload }) => {
          state.eligibilityRequestStatus = 'success'
          // according to the docs 'Y' is for eligible and 'M' for not eligible
          state.isUserEligible = payload.creditLimitEligible === 'Y'
        }
      )
  }
})

export const { resetCreditLineIncreaseAutoState } =
  creditLimitIncreaseAutoSlice.actions

export default creditLimitIncreaseAutoSlice.reducer
